/**
 * Sorts an array of objects numerically based on a specified field.
 * Objects without a numeric value in the specified field are placed at the end.
 *
 * @param {Object[]} data - The array of objects to sort.
 * @param {string} field - The key in each object to sort by (expects numeric values).
 * @param {'ASC' | 'DSC'} [order='ASC'] - The order to sort by: 'ASC' for ascending, 'DSC' for descending.
 * @param {boolean} [reverse=false] - reverse the order
 * @returns {Object[]} A new sorted array of objects, with blank or non-numeric values at the end.
 *
 * @example
 * const scores = [{ score: 10 }, { score: 0 }, { score: 50 }, { score: null }];
 * sortNumerically(scores, 'score'); // ASC: [{ score: 0 }, { score: 10 }, { score: 50 }, { score: null }]
 * sortNumerically(scores, 'score', 'DSC'); // DSC: [{ score: 50 }, { score: 10 }, { score: 0 }, { score: null }]
 */
export const sortNumerically = (
  data,
  field,
  order = 'ASC',
  reverse = false
) => {
  let newData = [...data];

  // Filter out entries with valid numeric values (including 0)
  let newDataValues = newData.filter((nd) => nd[field] || nd[field] === 0);
  const newDataBlank = newData.filter((nd) => nd[field] !== 0 && !nd[field]);

  // Sort descending first, will reverse for ASC later
  newDataValues = newDataValues.sort((a, b) => {
    return b[field] - a[field];
  });

  if (order === 'ASC') {
    newDataValues.reverse();
  }

  if (reverse) {
    newDataValues.reverse();
  }

  // Combine sorted numeric and blank values
  newData = [...newDataValues, ...newDataBlank];

  return newData;
};
